import { useContext } from "react";
import { LanguajeContext } from "../store/context";
import { translate } from "../languajes/languajes.js";

export const useTranslate = ( section) => {
  const { languaje } = useContext(LanguajeContext);

  return translate[languaje][section];
};
